import * as React from "react";

function EUPluginHybrid(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path d="M14 0.5C21.4541 0.5 27.5 6.54481 27.5 14C27.5 17.3083 26.3097 20.3382 24.3335 22.6864C21.856 25.6303 18.1459 27.5 14 27.5C6.54481 27.5 0.5 21.4541 0.5 14C0.5 6.54478 6.54478 0.5 14 0.5Z" fill="#B7E9B4" stroke="#58C150"/>
            <path d="M16.9389 5.48095V8.48882H11.1741V5.48095C11.1741 4.95074 10.7437 4.52032 10.2135 4.52032C9.68328 4.52032 9.25287 4.95074 9.25287 5.48095L9.25287 8.48882H7.33061H5.40936V10.4786H7.33061V15.4551C7.33061 18.964 9.8365 21.866 13.0954 22.3498V24.6874H15.0166V22.3498C18.2765 21.867 20.7824 18.965 20.7824 15.4551V10.4786H22.7036V8.48781H20.7824H18.8611V5.48095C18.8611 4.95074 18.4307 4.52032 17.9005 4.52032C17.3703 4.52032 16.9389 4.95074 16.9389 5.48095Z" fill="black"/>
            <path d="M13.8819 11.2C13.8819 11.2 13.2599 12.7951 12.1721 15.1206C11.0828 17.4461 12.3267 19.04 13.8819 19.04C15.4371 19.04 16.9915 17.7114 15.8425 15.5856C14.6957 13.4585 13.8819 11.2 13.8819 11.2Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="28" height="28" fill="white"/>
            </clipPath>
        </defs>
    </svg>
  );
}

export default EUPluginHybrid;

